module.exports = __webpack_public_path__ + "static/media/red-number-3.550f439b.png";